import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
// import Check from '@mui/icons-material/Check'
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import {useSelector} from "react-redux";
import BBIconBreachRiskScore from "../../../assets/bbCustomIcons/BBIconBreachRiskScore";
import {
    bbDangerousStringToDate,
    bbDoesCustomerHaveAccessToSubscriptionLevel,
    bbFindEntityWithinPortfolioOrSelf, bbGetSubscriptionLevelPropertyFromIdOrName, bbGetSubscriptionPropertyFromIdOrName
} from "../../../util/bbHelpers";
import BBIconVector from "../../../assets/bbCustomIcons/BBIconVector";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Skeleton from "react-loading-skeleton";
import BBIconRadarScanBoldSurvey from "../../../assets/bbCustomIcons/BBIconRadarScanBoldSurvey";
import BBIconPrepareWaitCurly from "../../../assets/bbCustomIcons/BBIconPrepareWaitCurly";
import {Check} from "@material-ui/icons";



const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#784af4',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#784af4',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
        color: '#784af4',
    }),
    '& .QontoStepIcon-completedIcon': {
        color: '#784af4',
        zIndex: 1,
        fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
}));

function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
        <QontoStepIconRoot ownerState={{ active }} className={className}>
            {completed ? (
                <Check className="QontoStepIcon-completedIcon" />
            ) : (
                <div className="QontoStepIcon-circle" />
            )}
        </QontoStepIconRoot>
    );
}

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 15,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:

            'linear-gradient( 95deg,rgb(148,158,32) 0%, rgb(186,199,40) 60%, rgb(219,235,46) 100%)',
            boxShadow: '0 2px 5px 0 rgba(0,0,0,.4)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg, rgb(148,158,32) 10%, rgb(71,77,15) 55%)',
            boxShadow: '0 2px 5px 0 rgba(0,0,0,.15)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 33,
    height: 33,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        backgroundImage:
            'linear-gradient( 136deg, rgb(105,165,255) 0%, rgb(105,165,255) 55%)',
        // 'linear-gradient( 136deg, rgb(40,54,139) 0%, rgb(40,54,139) 55%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.50)',
    }),
    ...(ownerState.completed && {
        backgroundImage:
            'linear-gradient( 136deg,  rgb(40,54,139) 10%, rgb(40,54,139) 55%)',
        boxShadow: '0 3px 8px 0 rgba(0,0,0,.25)',
    }),
}));

function ColorlibStepIconForTesting(props) {
    const { active, completed, className } = props;
    const activeDisplayText = active ? "(In Progress)" : completed ? "(Complete)" : "(Upcoming)";

    const icons = {
        1: <Tooltip title={`${activeDisplayText} This is the preparation phase. Soon, another survey, testing, and scoring cycle will be conducted.`}><span><BBIconPrepareWaitCurly /></span></Tooltip>,
        2: <Tooltip title={`${activeDisplayText} This is the survey phase. Next, vectors will be tested if Penetration Testing is enabled. This may take several days, after which the data will be scored.`}><span><BBIconRadarScanBoldSurvey /></span></Tooltip>,
        3: <Tooltip title={`${activeDisplayText} This is the testing phase. If Penetration Testing is enabled, vectors discovered will be tested to better measure risk.`}><span><BBIconVector /></span></Tooltip>,
        4: <Tooltip title={`${!active ? activeDisplayText : ""} This is the score phase. A score has been issued. In the future, another cycle will be prepared and conducted.`}><span><BBIconBreachRiskScore /></span></Tooltip>,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}

function ColorlibStepIcon(props) {
    const { active, completed, className } = props;

    const activeDisplayText = active ? "(In Progress)" : completed ? "(Complete)" : "(Upcoming)";

    const icons = {
        1: <Tooltip title={`${activeDisplayText} This is the preparation phase. Soon, another survey and scoring cycle will be conducted.`}><span><BBIconPrepareWaitCurly /></span></Tooltip>,
        2: <Tooltip title={`${activeDisplayText} This is the survey phase. This may take several days, after which the data will be scored.`}><span><BBIconRadarScanBoldSurvey /></span></Tooltip>,
        3: <Tooltip title={`${!active ? activeDisplayText : ""} This is the score phase. A score has been issued. In the future, another cycle will be prepared and conducted.`}><span><BBIconBreachRiskScore /></span></Tooltip>,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
};



const CycleProgressStepper = ({}) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {entityInView, portfolios } = useSelector(({breachrisk}) => breachrisk);
    const customerId = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerInView] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerId);

    const isCycleOngoing = myEntity && myEntity.settings && myEntity.settings.cycle_ongoing;
    const nextCycleDatetime = myEntity && myEntity.settings && myEntity.settings.next_cycle_datetime && bbDangerousStringToDate(myEntity.settings.next_cycle_datetime);
    const now = Date.now();
    const daysUntil = Math.floor((nextCycleDatetime - now)/1000/60/60/24) + 1;

    const isNextCycleScheduledToStartSoon = daysUntil < 2;

    const brfbSubId = bbGetSubscriptionPropertyFromIdOrName("BRfB", "id")
    const proLevelId = bbGetSubscriptionLevelPropertyFromIdOrName("pro", "id")

    const hasTesting = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, brfbSubId , proLevelId, true);

    const ongoingCycleStepId = myEntity && isCycleOngoing  && myEntity.cycle_ongoing_stage && myEntity.cycle_ongoing_stage.id;

    //0 Queued for recon
    //1 Recon ongoing
    //2 attack surface enumeration
    //3 crawling ongoing
    //4 queued for attack vector search
    //5 attack vector search
    //6 queued for attack vector validation
    //7 vector validation ongoing
    //8 queued for attack vector test prep
    //9 vector test prep ongoing
    //10 queued for attack vector testing
    //11 vector testing
    //12 queued for BR score
    //13 BR score calculation
    //14 assessment complete
    //15 assessment certified

    // console.log("nextCycleDatetime", nextCycleDatetime, "ongoingCycleStepId", ongoingCycleStepId, "daysUntil", daysUntil, "isNextCycleScheduledToStartSoon", isNextCycleScheduledToStartSoon, "hasTesting", hasTesting, "brfbSubId", brfbSubId);

    const steps = hasTesting
        ? ['Prepare', 'Survey', 'Test', 'Score']
        : ['Prepare', 'Survey', 'Score'];

    let activeStep = 2;
    if(hasTesting){
        activeStep = 3;

        if(isCycleOngoing){
            //check the specific steps
            switch(ongoingCycleStepId){
                case 0: //queued recon
                    activeStep = 0;
                    break;
                case 1: //recon ongoing
                    activeStep = 1;
                    break;
                case 2:
                    activeStep = 1;
                    break;
                case 3:
                    activeStep = 1;
                    break;
                case 4:
                    activeStep = 1;
                    break;
                case 5:
                    activeStep = 1;
                    break;
                case 6:
                    activeStep = 1;
                    break;
                case 7:
                    activeStep = 1;
                    break;
                case 8: //queued for testing
                    activeStep = 2;
                    break;
                case 9:
                    activeStep = 2;
                    break;
                case 10:
                    activeStep = 2;
                    break;
                case 11:
                    activeStep = 2;
                    break;
                case 12: //queued for breachrisk score
                    activeStep = 2;
                    break;
                case 13:
                    activeStep = 2;
                    break;
                case 14:
                    activeStep = 2;
                    break;
                case 15: //score certified
                    activeStep = 3;
                    break;
                default:
                    activeStep = 1;
                    break;
            }
        }else if(
            //if its close to the promosed date or actually in the queue for recon
            isNextCycleScheduledToStartSoon
            || ongoingCycleStepId === 0
        ){
            activeStep = 0;
        }
    } else {
        activeStep = 2;
        if(isCycleOngoing){
            //check the specific steps
            switch(ongoingCycleStepId){
                case 0: //queued recon
                    activeStep = 0;
                    break;
                case 1: //recon ongoing
                    activeStep = 1;
                    break;
                case 2:
                    activeStep = 1;
                    break;
                case 3:
                    activeStep = 1;
                    break;
                case 4:
                    activeStep = 1;
                    break;
                case 5:
                    activeStep = 1;
                    break;
                case 6:
                    activeStep = 1;
                    break;
                case 7:
                    activeStep = 1;
                    break;
                case 8: //queued for testing
                    activeStep = 1;
                    break;
                case 9:
                    activeStep = 1;
                    break;
                case 10:
                    activeStep = 1;
                    break;
                case 11:
                    activeStep = 1;
                    break;
                case 12: //queued for breachrisk score
                    activeStep = 1;
                    break;
                case 13:
                    activeStep = 1;
                    break;
                case 14:
                    activeStep = 1;
                    break;
                case 15: //score certified
                    activeStep = 2;
                    break;
                default:
                    activeStep = 1;
                    break;
            }
        }else if(isNextCycleScheduledToStartSoon){
            activeStep = 0;
        }
    }

    if(!myEntity || !customer) {
        return(
            <Stack sx={{ width: '100%' }} spacing={1}>
                <Skeleton/>
                <Skeleton/>
            </Stack>
        )
    } else {
        return (
            <Stack sx={{ width: '100%' }} spacing={1}>
                <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel StepIconComponent={hasTesting ? ColorlibStepIconForTesting : ColorlibStepIcon}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Stack>
        );
    }


}

export default CycleProgressStepper;